<template>
  <div>
    <div class="d-flex justify-content-end" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center" @click="redirectDetailPage">
        <div class="new-task-text">{{ $t("data-breach.new") }}</div>
        <div class="plus-button" style="margin-right: 1.56rem;"></div>
      </div>
    </div>
    <div v-if="pagination && pagination.docs.length > 0" class="d-flex justify-content-end" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center">
        <b-dropdown split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="mr-4">
          <b-dropdown-item @click="downloadExcel" href="#">{{ $t("data-breach.export-as-excel") }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <h2>{{ $t("data-breach.plural") }}</h2>

    <table class="table table-bordered compact ">
      <thead class="bg-dark text-white">
        <tr>
          <th scope="col" style="width:300px">
            <sortable-table-head field="name" :text="$t('data-breach.name')" tag="span" :request="request" />
          </th>
          <th scope="col" style="width:300px">{{ $t("data-breach.source-and-type.text") }}</th>
          <th scope="col" style="width:300px">{{ $t("data-breach.notificate-info") }}</th>
          <th scope="col" style="width:300px">{{ $t("risk.list") }}</th>

          <th scope="col" style="width: 15%">
            <a href="javascript:;" @click="toggleFilter">
              <span v-if="filterEnabled" class="text-warning">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-hide") }}
              </span>
              <span v-else class="text-light">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-show") }}
              </span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filterEnabled">
          <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>

          <th><input class="form-control " v-model="sourceAndTypeFilter" :placeholder="$t('common.search')" /></th>

          <th></th>
        </tr>

        <template v-if="pagination">
          <tr v-for="item in pagination.docs" :key="item._id">
            <td>
              {{ item.name | translate }}
            </td>
            <td>
              {{ item.sourceAndType | translate }}
            </td>

            <td>{{ item.questionWantToNotificate ? $t("common.yes") : $t("common.no") }}</td>
            <td>
              <ul>
                <li v-for="risk in item.risks" :key="risk._id">
                  <router-link :to="`/gdpr/risk-detail/${risk._id}`" target="_blank">
                    <i class="fa fa-link"></i>
                    {{ risk.name | translate }}
                  </router-link>
                </li>
              </ul>
            </td>

            <td>
              <div class="font-size-16 text-center">
                <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                <i class="bx bx-trash text-danger hand ml-2" v-b-tooltip.hover :title="$t('common.edit')" @click="deleteById(item)"></i>
              </div>
            </td>
          </tr>
          <!-- --table data end -->
        </template>
      </tbody>
    </table>

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("data.no-data") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: { products: { isObject: true } },
      },
      nameFilter: undefined,
      sourceAndTypeFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationDataBreachBreach/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationDataBreach/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDataBreachBreach/isLoading"];
    },
    hasViewPermission() {
      return true;
    },
    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    sourceAndTypeFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, sourceAndType: { value: n } };
      } else {
        this.request.query["sourceAndType"] = null;
        delete this.request.query["sourceAndType"];
      }
    },
  },

  methods: {
    redirectDetailPage() {
      this.$router.push(`/${this.currentProduct.toLowerCase()}/data-breach/create`);
    },
    isDownloading(id) {
      return this.$store.getters[`organizationDataBreach/isDownloading`](id);
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const { data: file } = await this.$store.dispatch(`organizationDataBreach/prepareExcelExport`);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async paginate() {
      try {
        this.request.query.products.value = this.currentProduct;
        await this.$store.dispatch("organizationDataBreach/paginate", this.request);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDataBreach/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    edit(item) {
      this.$store.commit("organizationDataBreach/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-breach");
      this.$router.push(`/${this.currentProduct.toLowerCase()}/data-breach-detail/${item._id}`);
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: { products: { isObject: true } },
        };
        this.nameFilter = undefined;
      }
    },
  },
};
</script>
